import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { Payment } from 'app/shared/models/class/payment/payment';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { PaymentService } from 'app/shared/services/payment/payment.service';

@Component({
  selector: 'app-admin-payments',
  templateUrl: './admin-payments.component.html',
  styleUrls: ['./admin-payments.component.scss']
})
export class AdminPaymentsComponent implements OnInit {

  title: string;
  searchForm: UntypedFormGroup;
  valueInput: string;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  clubCode: any;
  userConnected: any;
  payments: Payment[];
  tab = 'all';
  data: Payment[] = [];

  constructor(
    private faIconService: FaiconService,
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
    private paymentService: PaymentService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }


  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(event): void {
    this.valueInput = event;
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
  }

  changeTab(tab: string): void {
    this.tab = tab;
    this.data = this.getData();
    this.applyFilter(this.valueInput);
  }

  private getData(): Payment[] {
    const filter = {
      all: this.payments,
      online: this.filterData(true),
      counter: this.filterData(),
    };

    return filter[this.tab];
  }

  private filterData(withOrWithout: boolean = false): Payment[] {
    return this.payments?.filter(p => withOrWithout ? p.paymentType === 'Online' : p.paymentType !== 'Online');
  }

  private getPayments(): void {
    this.paymentService.getPayments(this.clubCode).subscribe({
      next: payments => {
        this.payments = payments;
        this.data = [...payments];
      }
    });
  }

  private getElementByRole(): void {
    const title = {
      club: 'Liste des paiements de mon club',
      admin: `Liste des paiements pour le club: ${this.clubCode}`
    };

    this.title = title[this.userConnected.role];
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.clubCode = this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode : this.userConnected.club_code;
    this.getElementByRole();
    this.getPayments();
  }

  private initForm() {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

}
